import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // 30 seconds to reduce staleness
      gcTime: 1000 * 60 * 10, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
    },
  },
});

// Query keys factory for consistent cache management
export const queryKeys = {
  articles: {
    all: ['articles'] as const,
    lists: () => [...queryKeys.articles.all, 'list'] as const,
    list: (filters: Record<string, any>) => [...queryKeys.articles.lists(), filters] as const,
    details: () => [...queryKeys.articles.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.articles.details(), id] as const,
  },
  dashboard: {
    all: ['dashboard'] as const,
    stats: () => [...queryKeys.dashboard.all, 'stats'] as const,
  },
  automation: {
    all: ['automation'] as const,
    jobs: () => [...queryKeys.automation.all, 'jobs'] as const,
    job: (id: string) => [...queryKeys.automation.all, 'job', id] as const,
  },
  monitoring: {
    all: ['monitoring'] as const,
    errors: () => [...queryKeys.monitoring.all, 'errors'] as const,
    logs: () => [...queryKeys.monitoring.all, 'logs'] as const,
  },
  seo: {
    all: ['seo'] as const,
    health: () => [...queryKeys.seo.all, 'health'] as const,
    schemas: () => [...queryKeys.seo.all, 'schemas'] as const,
  },
};
